export default {
    login: {
        error  : 'Something went Wrong! Try Again.',
        success: 'Welcome :)',
    },
    register: {
        success: 'Account has been Created Successfully! ',
        error  : '',
    },
    forget: {
        success_reset: 'Account Password has been changed Successfully! ',
    },
};
